<template>
    <div>

        <menu-bar></menu-bar>

        <div class="container" role="main">

            <div class="row" style="margin-top: 50px" v-if="cliente">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/atendimento-acoes">AÇÕES</a></li>
                    <li class="active">CADASTRO DE AÇÔES</li>
                </ol>

                <div class="row">
                    <div class="col-md-3">
                        <menu-atendimento-acoes/>
                    </div>
                    <div class="col-md-9" >

                        <form class="form-horizontal">

                            <div class="panel panel-info">
                                <!-- Default panel contents -->
                                <div class="panel-heading">
                                    <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                                </div>
                                <div class="panel-body">
                                    <div class="form-group">

                                        <div class="col-sm-12">
                                            <label :class="{'text-danger': !cliente.nome}" class="control-label">AÇÃO DO MONITOR</label>
                                            <input :disabled="user.level >= 5" type="text" v-model="cliente.nome" class="form-control" >
                                        </div>

                                    </div>
                                </div>

                            </div>

                            <div class="form-group">
                                <div class="col-sm-10">
                                    <button type="button" v-if="user.level < 5" :disable="! cliente.nome"
                                            @click="save()" class="btn btn-success">
                                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR AÇÃO DO MONITOR
                                    </button>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import MenuAtendimentoAcoes from "../../../menus/atendimento-acoes.vue";
import { AtendimentoAcoes } from "../../../class/index";

export default {
    components: {
        MenuAtendimentoAcoes
    },
    data() {
        return {
            cliente: null,
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.load(this.$route.params.id);
        } else {
            this.cliente = AtendimentoAcoes.create();
        }
    },
    methods: {
        load(id) {
            AtendimentoAcoes.byID(id)
                .then(row => (this.cliente = row))
                .catch(err => {
                    console.log(err);
                });
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar a ação?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            AtendimentoAcoes.save(this.cliente)
                                .then(() => {
                                    resolve();
                                    this.$router.push({
                                        path: "/atendimento-acoes"
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
